export default __webpack_public_path__ + "static/media/notification-dark.62c6ab9c.svg";